import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type ListCreditCardAccountsParams } from '@webapp/modules/accounts-payable/business-logic/interfaces/ICreditCardAccountRepository'
import { creditCardAccountRepository } from '../data-access/repositories/CreditCardAccountRepository'

const base = ['credit-card-accounts']

// Prefix of every list(params) key — command Models invalidate all list
// variants through this.
export const CREDIT_CARD_ACCOUNT_LIST_BASE_KEY = [...base, 'list']

export const creditCardAccountQueries = {
  list: (params: ListCreditCardAccountsParams) => ({
    queryKey: buildQueryKey([...CREDIT_CARD_ACCOUNT_LIST_BASE_KEY, params]),
    queryFn: () => creditCardAccountRepository.list(params),
  }),
  detail: (id: number) => ({
    queryKey: buildQueryKey([...base, 'detail', id]),
    queryFn: () => creditCardAccountRepository.getById(id),
  }),
}
